// Module
var code = "<span class=\"badge badge-default\" style=\"margin-left:5px;color:#000!important;background-color:#f5f5f5!important;border-color:#ccc!important\" uib-popover=\"Nombre de valeurs propres\" popover-trigger=\"'mouseenter'\" popover-placement=\"top\" popover-append-to-body=\"true\"> {{ $ctrl.count }} </span> ";
// Exports
module.exports = code;